var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C.19 0 0 .908 0 8s.19 8 11 8 11-.908 11-8-.19-8-11-8zm3.525 8.347l-4.939 2.178c-.432.189-.786-.023-.786-.474V5.949c0-.45.354-.663.786-.474l4.94 2.178c.432.191.432.503 0 .694z",
    fill: "#002131"
  })));
}

export default SvgYoutube;